import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";
import {
  PMLevelCard,
  PMSmallStatus,
} from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";
import { getStreetlightStatusValue } from "../../../utils/dropdown-options";
import { getOverviewCardCopy } from "../get-card-copy";

export function addStatusAndCompletionCards(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
): void {
  const { language, getCardCopy } = getOverviewCardCopy(app);

  const statusComponent = view.addComponent({
    component: PMSmallStatus,
    layoutProps: {
      componentId: "statusComponent",
      title: "",
      description: "",
      labels: ["project-status"],
    },
  });

  statusComponent.mapLayoutProps(({ language }) => ({
    componentId: "statusComponent",
    labels: ["project-status"],
    title: getCardCopy(language, "overallStatus").title,
    description: getCardCopy(language, "overallStatus").description,
  }));

  statusComponent.mapState(({ dashboard, language }) => {
    const overallStatus = dashboard?._calculated?.overallStatus;
    return {
      title: getLocalizedMessage(language, "status") || "Status",
      primaryStatusIndicatorSize: "large",
      fixedHeight: "134px",
      status: getStreetlightStatusValue(overallStatus) ?? "",
    };
  });

  statusComponent.mapVisibility(({ settings }) => {
    return (
      (settings?.configuration?.statusReportingLevel ?? "overall") === "overall"
    );
  });

  const overallCompletionCard = view.addComponent({
    component: PMLevelCard,
    layoutProps: {
      componentId: "overallCompletionCard",
      title:
        getLocalizedMessage(language, "cards.overallCompletion.title") ||
        "Overall Completion Card",
      description: getLocalizedMessage(
        language,
        "cards.overallCompletion.description"
      ),
      labels: ["overallCompletion"],
    },
  });
  overallCompletionCard.mapState(({ dashboard, settings }) => {
    return {
      title:
        getLocalizedMessage(language, "cards.overallCompletion.title") ||
        "Overall Completion",
      categories: [
        {
          value: dashboard?._calculated?.overallCompletionDegree?.name ?? "",
          valueColor:
            settings?.configuration?.degreeOfCompletionDefinition?.find(
              (cat) =>
                cat.name ===
                dashboard?._calculated?.overallCompletionDegree?.name
            )?.color ?? "#E1F1E7",
          textColor: "#fff",
        },
      ],
      showInfoIcon: false,
      showMenuIcon: false,
    };
  });
}
